import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import PrincipalPercentOwnedRuleset from '../../business/ruleset/PrincipalPercentOwnedRuleset';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { RulesetResult } from '../../business/rules';

const {
  formField: { principalPercentOwned },
} = loanFormModel;

export class PrincipalPercentOwnedValidation implements ValidationSchema {
  public name = principalPercentOwned.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'number';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public typeError = {
    message: 'Must be a number',
    value: true,
  };
  public min = {
    message: 'Percentage must be a positive number',
    value: 0,
  };
  public max = {
    message: 'Please enter a valid percentage',
    value: 100,
  };

  public ruleset = PrincipalPercentOwnedRuleset;

  public when(schema: any, ...args: any[]) {
    return schema.test({
      name: 'principalPercentOwnedValidation',
      test: function (value, context) {
        const application: Partial<ApplicationFormValues> =
          this.from?.[1]?.value;

        const result: RulesetResult =
          PrincipalPercentOwnedRuleset.setPrincipalId(this.parent.id).evaluate(
            application
          );

        const isRequired = !!(result & RulesetResult.REQUIRED);

        if (!isRequired) return true;

        if (value === null || value === undefined || value === '') {
          return this.createError({
            message: principalPercentOwned.requiredErrorMsg,
          });
        }

        const total =
          application?.principals
            ?.map((p) => Number(p[principalPercentOwned.name]))
            .reduce((prev, curr) => prev + curr, 0) ?? 0;

        if (total > 100) {
          return this.createError({
            message:
              "Ownership percentage total for all principals can't exceed 100%",
          });
        }

        return true;
      },
    });
  }
}

export default new Validation(new PrincipalPercentOwnedValidation());
